import { formatarData } from 'src/app/core/utils/utilities';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { ModalAcessoRestritoComponent } from '../modal-acesso-restrito/modal-acesso-restrito.component';
import {
  ICreateSaidaGate,
  IGetSaidaGateByIdRepsonse
} from 'src/app/services/SaidaGateService/saidaGate.model';
import { SaidaGateService } from 'src/app/services/SaidaGateService/saidaGate.service';
import { EntradaGateService } from 'src/app/services/EntradaGateService/entradaGate.service';
import { ServicoEntradaService } from 'src/app/services/ServicoEntradaService/servicoEntrada.service';
import { ModalPagamentoSaidaComponent } from '../modal-pagamento-saida/modal-pagamento-saida.component';
import Swal from 'sweetalert2';
import { IGetServicoEntradaPrecoByEntrada } from 'src/app/services/ServicoEntradaService/servicoEntrada.model';
import {
  IGetGateEntradasInfoResponse,
  Items
} from 'src/app/services/EntradaGateService/entradaGate.model';
import { PagamentoSaidaService } from 'src/app/services/PagamentoSaida/pagamentoSaida.service';
import { EngateDesengateService } from 'src/app/services/EngateDesengateService/engateDesengate.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { ImpressoraService } from 'src/app/services/ImpressoraService/impressora.service';
import { IGetReportBase64 } from 'src/app/services/ReportService/report.model';
import { decidirImpressaoPrePatio } from 'src/app/core/utils/ticket-saida-print';
import { ModalEmpresasFaturadasComponent } from '../modal-empresas-faturadas/modal-empresas-faturadas.component';

@Component({
  selector: 'app-cadastro-saida-gate',
  templateUrl: './cadastro-saida-gate.component.html',
  styleUrls: ['./cadastro-saida-gate.component.scss']
})
export class CadastroSaidaGateComponent implements OnInit, OnDestroy {
  private subscription$ = new Subscription();
  form: FormGroup;
  guid: string = generateUUID();
  title: string = 'Saída no Gate';
  backRoute: string = 'listagem/saida-gate';
  isEmpresaFaturada: boolean = false;
  isEditing: boolean = false;
  isViewing: boolean = false;
  isDesengatado: boolean = false;
  isLoading: boolean = false;
  lockGetEntrada: boolean = false;
  entradaCarregada: {
    pk: number | null;
    agnd: number | null;
    placa: string;
  } | null = null;

  vlPagamento: number = 0;
  vlPrePatio: number = 0;
  flPrePatio: boolean = false;

  tableData: any[] = [];

  tableColumns = [
    {
      header: '',
      key: 'selecionado',
      type: 'checkbox',
      action: (item: any) => {
        this.selectServico(item);
      },
      // Usa flag da linha (evita esconder checkbox por estado global / binding).
      condition: (item: any) => item?.podePagar === true,
      default: true
    },
    { header: 'Serviço', key: 'servico', type: 'text', default: true },
    {
      header: 'Início do Serviço',
      key: 'inicioServico',
      type: 'text',
      default: true
    },
    { header: 'Valor', key: 'valor', type: 'text', default: true }
  ];

  constructor(
    public dialog: MatDialog,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private entradaGateService: EntradaGateService,
    private saidaGateService: SaidaGateService,
    private servicoEntradaService: ServicoEntradaService,
    private pagamentoSaidaService: PagamentoSaidaService,
    private engateDesengateService: EngateDesengateService,
    public swalAlert: SwalAlertService,
    private impressoraService: ImpressoraService
  ) {
    this.form = this.initForm();
  }

  ngOnInit(): void {
    this.form.get('TX_PLCA_CAVA')?.valueChanges.subscribe((value) => {
      if (value && typeof value === 'string') {
        this.form
          .get('TX_PLCA_CAVA')
          ?.setValue(value.toUpperCase(), { emitEvent: false });
      }
    });
    this.activateRoute();
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  initForm() {
    const form = this.fb.group({
      FK_GATE_ENTR: this.fb.control(null, {
        validators: [Validators.required]
      }),
      TX_PLCA_CAVA: this.fb.control('', {
        validators: [Validators.required]
      }),
      PK_AGND: this.fb.control(null, {}),
      CD_SAID_GATE: this.fb.control(null, {}),
      NM_MTRT: this.fb.control('', {}),
      TX_PLCA_CRTS: this.fb.control('', {}),
      PK_EPSA: this.fb.control(null, {}),
      NM_EPSA: this.fb.control('', {}),
      DT_AGND: this.fb.control({ value: '---', disabled: true }),
      JANELA: this.fb.control({ value: '---', disabled: true }),
      VL_TOTL: this.fb.control({ value: 0, disabled: true }),
      VL_PAGO: this.fb.control({ value: 0, disabled: true }),
      VL_REST: this.fb.control({ value: 0, disabled: true }),
      VL_ACRM: this.fb.control({ value: 0, disabled: true }),
      VL_DSCT: this.fb.control({ value: 0, disabled: true }),
      VL_DSCT_PREV: this.fb.control({ value: 0, disabled: true }),
      VL_PRE_PTIO: this.fb.control({ value: 0, disabled: true }),
      TX_OBSV_GATE_SAID: this.fb.control('', {})
    });
    return form;
  }

  private formatarJanela(hrInic?: string | null, hrFim?: string | null): string {
    const normalize = (value?: string | null): string => {
      if (value == null || value === '') return '';
      const match = String(value).match(/(\d{2}):(\d{2})/);
      return match ? `${match[1]}:${match[2]}` : String(value).substring(0, 5);
    };
    const inicio = normalize(hrInic);
    const fim = normalize(hrFim);
    if (inicio && fim) return `${inicio} - ${fim}`;
    if (inicio) return inicio;
    return '---';
  }

  createSaida() {
    if (!this.isEditing) this.postSaida();
    if (this.isEditing) this.updateSaida();
  }

  postSaida(): void {
    const payload = this.createPayload();
    this.guid = generateUUID();
    this.isLoading = true;
    this.saidaGateService.CreateSaidaGate(payload, this.guid).subscribe({
      next: (res: any) => {
        this.imprimirTicket(res.PK_GATE_SAID, false);
        this.router.navigate(['listagem/saida-gate']);
      },
      error: (err) => {
        this.isLoading = false;
        this.swalAlert.handleError(err, 'Erro!', 'Não foi possível registrar a saída.');
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  updateSaida(): void {
    const payload = this.createPayload();
    const id = this.form.controls['CD_SAID_GATE'].value;
    if (!id) return;
    this.isLoading = true;
    this.saidaGateService.UpdateSaidaGate(payload, id).subscribe({
      next: () => {
        this.swalAlert.showAlertOnConfirmNavigate(
          'Sucesso!',
          'Saída editada com sucesso.',
          'success',
          'listagem/saida-gate',
          true
        );
      },
      error: (err) => {
        this.swalAlert.handleError(err, 'Erro!', 'Erro ao editar saída.', 'warning');
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  createPayload(): ICreateSaidaGate {
    const FK_FUNC_OPER = Number(localStorage.getItem('id'));

    if (this.isEmpresaFaturada) {
      return {
        TX_OBSV_GATE_SAID: this.form.controls['TX_OBSV_GATE_SAID'].value,
        VL_ACRM: this.form.controls['VL_ACRM'].value,
        VL_DSCT: this.form.controls['VL_DSCT'].value,
        FK_GATE_ENTR: this.form.controls['FK_GATE_ENTR'].value,
        FK_FUNC_OPER: FK_FUNC_OPER
      };
    }
    return {
      FK_GATE_ENTR: this.form.controls['FK_GATE_ENTR'].value,
      TX_OBSV_GATE_SAID: this.form.controls['TX_OBSV_GATE_SAID'].value,
      FK_FUNC_OPER: FK_FUNC_OPER
    };
  }

  getSaida(id: number) {
    this.isLoading = true;

    this.saidaGateService.GetSaidasById(id).subscribe({
      next: (response: IGetSaidaGateByIdRepsonse) => {
        this.isLoading = false;

        this.form.controls['TX_OBSV_GATE_SAID'].setValue(
          response.TX_OBSV_GATE_SAID ?? 'Não informado'
        );
      },
      error: (error: any) => {
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  private normalizePlaca(value: string | null | undefined): string {
    return String(value ?? '')
      .replace(/-/g, '')
      .replace(/\s/g, '')
      .trim()
      .toUpperCase();
  }

  private jaCarregouEntrada(type: string, value: any): boolean {
    if (!this.entradaCarregada) {
      return false;
    }

    if (type === 'FK_GATE_ENTR') {
      return Number(value) === Number(this.entradaCarregada.pk);
    }

    if (type === 'PK_AGND') {
      return (
        this.entradaCarregada.agnd != null &&
        Number(value) === Number(this.entradaCarregada.agnd)
      );
    }

    if (type === 'TX_PLCA_CAVA') {
      return this.normalizePlaca(value) === this.entradaCarregada.placa;
    }

    return false;
  }

  getEntrada(type: string) {
    const params: { [key: string]: any } = {};
    const value = this.form.controls[type].value ?? '';

    if (this.lockGetEntrada) {
      return;
    }

    if (this.jaCarregouEntrada(type, value)) {
      return;
    }

    if (type === 'TX_PLCA_CAVA') {
      const placa = this.normalizePlaca(value);
      if (!placa || placa.length < 7) {
        return;
      }
      params['TX_PLCA_CAVA'] = placa;
    } else if (!value) {
      return;
    }

    if (type === 'FK_GATE_ENTR' && String(value).length === 0) {
      this.entradaCarregada = null;
      this.form.reset();
      this.tableData = [];
      return;
    }

    if (type === 'PK_AGND' && String(value).length === 0) {
      this.entradaCarregada = null;
      this.form.reset();
      this.tableData = [];
      return;
    }

    if (type === 'FK_GATE_ENTR' && value) {
      params['PK_GATE_ENTR'] = value;
    }

    if (type === 'PK_AGND') {
      params['FK_AGND'] = value;
    }

    if (Object.keys(params).length === 0) {
      return;
    }

    this.lockGetEntrada = true;
    this.isLoading = true;

    this.entradaGateService
      .GetGateEntradaWithCaminhaoAtualInfoById(params)
      .subscribe({
        next: (res: Items) => {
          this.isLoading = false;

          if (res.FK_GATE_SAID && !this.isEditing && !this.isViewing) {
            this.swalAlert.showAlert(
              'Atenção!',
              'Essa entrada já realizou uma saída.',
              'warning'
            );
            this.lockGetEntrada = false;
            this.entradaCarregada = null;
            this.form.reset();
            return;
          }

          if (res.PK_GATE_ENTR == null || res.PK_GATE_ENTR < 1) {
            this.swalAlert.showAlert(
              'Atenção!',
              'Entrada não encontrada.',
              'warning'
            );
            this.lockGetEntrada = false;
            return;
          }

          const item = res;

          this.getDesconto(item.PK_GATE_ENTR);
          this.getTotalizadores(item.PK_GATE_ENTR);

          this.engateDesengateService
            .VerifyComponentesByEngate(item.PK_GATE_ENTR)
            .subscribe({
              next: () => {
                const carretas = `${item.TX_PLCA_CRRT1 || ''}${item.TX_PLCA_CRRT2 ? ' | ' + item.TX_PLCA_CRRT2 : ''
                  }${item.TX_PLCA_CRRT3 ? ' | ' + item.TX_PLCA_CRRT3 : ''}`;

                this.form.controls['FK_GATE_ENTR'].setValue(item.PK_GATE_ENTR);
                this.form.controls['PK_AGND'].setValue(item.PK_AGND);
                this.form.controls['TX_PLCA_CAVA'].setValue(item.TX_PLCA_CAVA, {
                  emitEvent: false
                });
                this.form.controls['NM_MTRT'].setValue(item.NM_MTRT);
                const carretasList = [
                  item.TX_PLCA_CRRT1,
                  item.TX_PLCA_CRRT2,
                  item.TX_PLCA_CRRT3
                ].filter(val => val);
                this.form.controls['TX_PLCA_CRTS'].setValue(
                  carretasList.join(' | ')
                );
                this.form.controls['PK_EPSA'].setValue(item.PK_EPSA);
                this.form.controls['NM_EPSA'].setValue(item.NM_EPSA);
                this.form.controls['DT_AGND'].setValue(
                  item.DT_AGND ? formatarData(item.DT_AGND) : '---'
                );
                this.form.controls['JANELA'].setValue(
                  this.formatarJanela(item.HR_INIC_JNLA, item.HR_FIM_JNLA)
                );
                this.form.controls['VL_PAGO'].setValue(item.VL_PAGO ?? 0.0);
                this.flPrePatio = !!item.FL_PRE_PTIO;
                this.vlPrePatio = item.VL_PRE_PTIO ?? 0;
                this.form.controls['VL_PRE_PTIO'].setValue(this.vlPrePatio);

                if (!this.isEditing && !this.isViewing) {
                  this.form.controls['TX_OBSV_GATE_SAID'].setValue(
                    item.TX_OBSV_GATE_ENTR
                  );
                }

                if (item.FL_FTRD_EPSA === 3 && !this.isViewing) {
                  this.isEmpresaFaturada = true;
                  this.form.controls['VL_ACRM'].enable();
                  this.form.controls['VL_DSCT'].enable();
                }

                this.isDesengatado = item.FL_DSGT;
                this.entradaCarregada = {
                  pk: item.PK_GATE_ENTR,
                  agnd: item.PK_AGND ?? null,
                  placa: this.normalizePlaca(item.TX_PLCA_CAVA)
                };

                this.isLoading = false;
                this.lockGetEntrada = false;
              },
              error: (err) => {
                this.swalAlert.handleError(
                  err,
                  'Atenção!',
                  'Erro ao verificar a entrada.',
                  'info'
                );
                this.isLoading = false;
                this.lockGetEntrada = false;
              },
              complete: () => {
                this.getTabela();
              }
            });
        },
        error: (err) => {
          this.isLoading = false;
          this.lockGetEntrada = false;
          if (this.entradaCarregada || this.form.controls['FK_GATE_ENTR'].value) {
            return;
          }
          this.swalAlert.handleError(
            err,
            'Atenção!',
            'Nenhuma entrada ativa encontrada para os dados informados.',
            'warning'
          );
        },
        complete: () => {
          this.isLoading = false;
        }
      });
  }

  private isNomePrePatio(nome: string | null | undefined): boolean {
    const n = String(nome ?? '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z]/g, '');
    return n.includes('prepatio');
  }

  private aplicarLinhaPrePatio(): void {
    this.tableData = this.tableData.map((servico: any) => {
      if (this.isNomePrePatio(servico.servico)) {
        const status = Number(servico.status);
        const pago = status === 2 || !!servico.pago;
        const faturado = status === 3 || !!servico.faturado;
        return {
          ...servico,
          isPrePatio: true,
          podePagar:
            !this.isEditing &&
            !this.isViewing &&
            !pago &&
            !faturado
        };
      }
      return servico;
    });

    if (!this.flPrePatio || this.vlPrePatio <= 0) {
      return;
    }

    const jaExiste = this.tableData.some(
      (servico: any) => servico.isPrePatio || this.isNomePrePatio(servico.servico)
    );
    if (jaExiste) {
      return;
    }

    this.tableData = [
      {
        id: -1,
        isPrePatio: true,
        selecionado: false,
        servico: 'Pré-Pátio',
        inicioServico: '---',
        valor: this.vlPrePatio.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }),
        pago: false,
        status: 1,
        faturado: false,
        podePagar: !this.isEditing && !this.isViewing,
        tipoServico: null
      },
      ...this.tableData.filter((servico: any) => !servico.isPrePatio)
    ];
  }

  getTabela(onComplete?: () => void) {
    const FK_GATE_ENTR = this.form.controls['FK_GATE_ENTR'].value;
    const invalid = [null, NaN, ''];
    if (!invalid.includes(FK_GATE_ENTR)) {
      this.isLoading = true;
      this.servicoEntradaService.GetServicoByPreco(FK_GATE_ENTR).subscribe({
        next: (res: IGetServicoEntradaPrecoByEntrada) => {
          const lista = Array.isArray(res) ? res : [];
          this.tableData = lista.map(item => {
            const isPrePatio = this.isNomePrePatio(item.TX_TIPO_SRVC);
            const statusParsed = Number(item.FL_SRVC_ENTR_STTS);
            // Sem status válido, trata como em aberto para não esconder o checkbox.
            const status = Number.isFinite(statusParsed) ? statusParsed : 1;
            const faturado = status === 3 || Number(item.FK_EPSA_FTRD) > 0;
            // Em aberto (1): nunca bloquear por IS_PAGO inconsistente.
            const pago = status === 2 || (status !== 1 && !!item.IS_PAGO);
            const podePagar =
              !this.isEditing &&
              !this.isViewing &&
              !pago &&
              !faturado;
            return {
              id: item.PK_SRVC_ENTR,
              selecionado: false,
              servico: item.TX_TIPO_SRVC,
              inicioServico: formatarData(item.DT_SRVC_ENTR),
              valor: Number(item.VL_SRVC ?? 0).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
              }),
              pago,
              status,
              faturado,
              podePagar,
              tipoServico: item.PK_SRVC,
              isPrePatio
            };
          });
          this.aplicarLinhaPrePatio();
        },
        error: () => {
          this.tableData = [];
          this.aplicarLinhaPrePatio();
          this.calcValores();
          this.isLoading = false;
          onComplete?.();
        },
        complete: () => {
          this.calcValores();
          this.isLoading = false;
          onComplete?.();
        }
      });
    }
  }

  openEmpresasFaturadas() {
    if (this.disableFaturar()) return;

    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '680px';
    dialogConfig.disableClose = true;

    // console.log(this.tableData);

    const ids: number[] = this.tableData
      .filter(x => x.pago === false && !x.faturado && !x.isPrePatio)
      .map(x => x.id);

    dialogConfig.data = {
      id: this.form.controls['FK_GATE_ENTR'].value,
      servicosEntrada: ids
    };

    const dialogFaturamento = this.dialog.open(ModalEmpresasFaturadasComponent, dialogConfig);

    dialogFaturamento.afterClosed().subscribe((isFaturado) => {
      if (isFaturado) {
        this.isEmpresaFaturada = true;
        this.form.controls['VL_ACRM'].enable();
        this.form.controls['VL_DSCT'].enable();
      }

      this.getTabela();
      this.disablePagamento();
    });
  }

  openModalPagamento() {
    const dialogConfig = new MatDialogConfig();

    const FK_GATE_ENTR = this.form.controls['FK_GATE_ENTR'].value;
    const selecionados = this.tableData.filter((x: any) => x.selecionado);
    const prePatioReal = selecionados.find(
      (x: any) =>
        x.id > 0 && (x.isPrePatio || this.isNomePrePatio(x.servico))
    );
    const prePatioSintetico = selecionados.some((x: any) => x.id === -1);
    // Só materializa no backend se a linha for sintética e não houver pré-pátio real selecionado.
    const cobrarPrePatio = prePatioSintetico && !prePatioReal;
    const FK_SRVC_ENTR_LIST = selecionados
      .filter((x: any) => x.id > 0)
      .map((x: any) => x.id);
    const VL_TOTL = selecionados.reduce(
      (acc: number, x: any) => acc + this.parseCurrency(x.valor),
      0
    );

    dialogConfig.width = '680px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      FK_GATE_ENTR: FK_GATE_ENTR,
      FK_SRVC_ENTR_LIST: FK_SRVC_ENTR_LIST,
      VL_TOTL: VL_TOTL,
      FL_COBRAR_PRE_PTIO: cobrarPrePatio,
      VL_PRE_PTIO: cobrarPrePatio || !!prePatioReal ? this.vlPrePatio : 0
    };

    const dialogRef = this.dialog.open(
      ModalPagamentoSaidaComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe((isPaymentSuccessful) => {
      if (isPaymentSuccessful) {
        this.createSaida();
      } else {
        var idSaida = this.form.controls['CD_SAID_GATE'].value;
        if (idSaida != null) this.getSaida(idSaida);
        this.getEntrada('FK_GATE_ENTR');
        this.getTabela();
        this.getDesconto(this.form.controls['FK_GATE_ENTR'].value);
      }
    });
  }

  selectServico(item: any) {
    this.tableData = this.tableData.map((servico: any) => {
      if (servico.id === item.id) {
        servico.selecionado = !servico.selecionado;
      }
      return servico;
    });
    //this.getDesconto();
  }

  showBotaoPagamento(): boolean {
    if (
      !this.isEditing &&
      !this.isViewing &&
      this.form.controls['FK_GATE_ENTR'].value
    ) {
      return true;
    }
    return false;
  }

  getStatusPagamento(item: any): boolean {
    if (item?.podePagar === true) return true;
    if (this.isEditing || this.isViewing) return false;
    if (item?.faturado || item?.status === 3) return false;
    if (item?.status === 2 || item?.pago) return false;
    return true;
  }

  getDesconto(FK_GATE_ENTR: number): void {
    this.isLoading = true;
    this.pagamentoSaidaService
      .GetDescontoAgendamentoByGateEntrada(FK_GATE_ENTR)
      .subscribe({
        next: res => {
          this.isLoading = false;
          const VL_DSCT_AGND = res.VL_DSCT_AGND;
          this.form.controls['VL_DSCT_PREV'].setValue(VL_DSCT_AGND);
        },
        error: err => {
          this.isLoading = false;
        }
      });
    this.calcValores();
  }

  getTotalizadores(FK_GATE_ENTR: number): void {
    this.isLoading = true;
    this.pagamentoSaidaService
      .GetPagamentoSaidaTotalizadoresByEntrada(FK_GATE_ENTR)
      .subscribe({
        next: res => {
          this.form.controls['VL_DSCT'].setValue(
            res.VL_DSCT_TOTL + res.VL_DSCT_AUTO
          );
          this.form.controls['VL_ACRM'].setValue(res.VL_ACRM_TOTL);
          this.isLoading = false;
        },
        error: err => {
          this.isLoading = false;
        }
      });
  }

  calcValores(): void {
    if (this.isEmpresaFaturada) {
      const valorServicos = this.tableData.reduce(
        (acc, servico: any) => acc + this.parseCurrency(servico.valor),
        0
      );
      this.form.controls['VL_TOTL'].setValue(valorServicos);
      this.form.controls['VL_REST'].setValue(0);
      return;
    }

    const valorServicos = this.tableData.reduce(
      (acc: number, servico: any) =>
        acc + this.parseCurrency(servico.valor ?? '0,00'),
      0
    );

    const valorPago = this.form.get('VL_PAGO')?.value;

    const valorDesconto =
      this.tableData.reduce(
        (acc: number, servico: any) =>
          acc + this.parseCurrency(servico.desconto ?? '0,00'),
        0
      ) + this.form.controls['VL_DSCT'].value;

    const valorDescontoPrevio =
      this.tableData.reduce(
        (acc: number, servico: any) =>
          acc + this.parseCurrency(servico.desconto ?? '0,00'),
        0
      ) + this.form.controls['VL_DSCT_PREV'].value;

    const valorAcrescimo = this.tableData.reduce(
      (acc: number, servico: any) =>
        acc + this.parseCurrency(servico.acrescimo ?? '0,00'),
      0
    );

    const valorRestante = this.tableData
      .filter((x: any) => !x.pago && !x.faturado)
      .reduce(
        (acc: number, servico: any) =>
          acc + this.parseCurrency(servico.valor ?? '0,00'),
        0
      );

    this.form.controls['VL_TOTL'].setValue(valorServicos);
    this.form.controls['VL_REST'].setValue(valorRestante);
  }

  activateRoute(): void {
    this.route.queryParams.subscribe(params => {
      const idEntrada = params['idEntrada'];
      const codigoSaida = params['codigoSaida'];
      const placaCavalo = params['placaCavalo'];

      if (codigoSaida > 0) this.getSaida(codigoSaida);

      if (params['isFaturado'] === 'true') {
        this.form.controls['FK_GATE_ENTR'].setValue(params['PK_GATE_ENTR']);
        this.getEntrada('FK_GATE_ENTR');
      }

      if (params['isEditing'] === 'true') {
        this.title = 'Editar Saída no Gate';
        this.isEditing = true;
        this.backRoute = 'listagem/saida-gate';
        this.form.controls['FK_GATE_ENTR'].setValue(Number(idEntrada));
        this.form.controls['CD_SAID_GATE'].setValue(Number(codigoSaida));
        this.form.controls['TX_PLCA_CAVA'].setValue(String(placaCavalo));
        this.form.controls['FK_GATE_ENTR'].disable();
        this.form.controls['TX_PLCA_CAVA'].disable();
        this.getEntrada('FK_GATE_ENTR');
      }
      if (params['isViewing'] === 'true') {
        this.title = 'Visualização Saída no Gate';
        this.isViewing = true;
        this.backRoute = 'listagem/saida-gate';
        const idEntrada = params['idEntrada'];
        this.form.controls['FK_GATE_ENTR'].setValue(Number(idEntrada));
        this.getEntrada('FK_GATE_ENTR');
        this.form.disable();
      }
      if (params['isViewingCaixa'] === 'true') {
        this.title = 'Visualização Saída no Gate';
        this.isViewing = true;
        this.backRoute = 'listagem/caixa';
        const idEntrada = params['idEntrada'];
        this.form.controls['FK_GATE_ENTR'].setValue(Number(idEntrada));
        this.getEntrada('FK_GATE_ENTR');
        this.form.disable();
      }
      if (Number(params['isMode']) === 0) {
        console.log("Bateu");
        this.title = 'Cadastro de Saída no Gate';
        this.isEditing = false;
        this.isViewing = false;
        this.backRoute = 'listagem/entrada';
        this.form.controls['FK_GATE_ENTR'].setValue(idEntrada);
        this.getEntrada('FK_GATE_ENTR');
      }
    });
  }

  disableFaturar(): boolean {
    const FK_GATE_ENTR = this.form.controls['FK_GATE_ENTR'].value;
    const possuiServicoPendente = this.tableData.some(x => !x.pago && !x.faturado);

    if (!FK_GATE_ENTR) return true;
    if (!possuiServicoPendente) return true;
    if (this.isEmpresaFaturada) return true;

    return false;
  }

  disablePagamento(): boolean {
    const FK_SRVC_ENTR_LIST = this.tableData.filter((x: any) => x.selecionado);
    if (FK_SRVC_ENTR_LIST.length === 0) {
      return true;
    }
    return false;
  }

  disableCadastro(): boolean {
    const FK_GATE_ENTR = this.form.controls['FK_GATE_ENTR'].value;
    const VL_REST = this.form.controls['VL_REST'].value;

    if (this.isEditing || this.isViewing) return false;

    const servicosStatus = this.tableData.every(x => x.status == 2 || x.status == 3);

    if (
      FK_GATE_ENTR &&
      (this.isDesengatado || this.isEmpresaFaturada || VL_REST === 0 || servicosStatus)
    )
      return false;

    return true;
  }

  parseCurrency(value: string): number {
    const parsedValue = value.replace(/[^\d,-]/g, '').replace(',', '.');
    return parseFloat(parsedValue) || 0;
  }

  imprimirTicket(id: number, bloquearUi = true) {
    if (bloquearUi) this.isLoading = true;

    this.saidaGateService.GetReceiptGateSaidayId(id, 1).subscribe({
      next: async (response: IGetReportBase64) => {
        if (bloquearUi) this.isLoading = false;
        const tickets = await decidirImpressaoPrePatio(response.ReportBase64);
        this.enviarTickets(tickets);
      },
      error: _error => {
        if (bloquearUi) this.isLoading = false;
      }
    });
  }

  private enviarTickets(tickets: string[] | null) {
    if (!tickets?.length) return;
    tickets.forEach((ticket, index) => {
      setTimeout(() => {
        this.impressoraService.impressoraTicket(ticket, 'text/plain');
      }, index * 1200);
    });
  }
}
